import React from 'react';

interface TermsAndConditionsProps {
  onBack: () => void;
}

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ onBack }): React.ReactElement => {
  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: '#0a0e14',
      overflowY: 'auto',
      padding: '40px 20px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        maxWidth: '700px',
        margin: '0 auto',
        textAlign: 'left',
        color: '#e2e8f0',
      }}>
        <button
          onClick={onBack}
          style={{
            background: '#21262d',
            border: '1px solid #30363d',
            color: '#e2e8f0',
            padding: '8px 16px',
            cursor: 'pointer',
            marginBottom: '24px',
            fontSize: '12px',
          }}
        >
          ← Back to Sign In
        </button>

        <h1 style={{ textAlign: 'center', marginBottom: '8px' }}>Terms and Conditions</h1>
        <p style={{ textAlign: 'center', color: '#8b949e', fontSize: '12px', marginBottom: '32px' }}>
          Last updated: December 9, 2025
        </p>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>1. Acceptance of Terms</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            By accessing or using Grand Online ("the Game"), you agree to be bound by these Terms and 
            Conditions. If you do not agree to these terms, please do not use the Game.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>2. Description of Service</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            Grand Online is a multiplayer online game that allows users to explore, trade, and engage 
            in various gameplay activities. The Game is provided "as is" and may be modified, suspended, 
            or discontinued at any time without notice.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>3. User Accounts</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6', marginBottom: '12px' }}>
            To access certain features, you may need to create an account. You agree to:
          </p>
          <ul style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>Notify us immediately of any unauthorized use</li>
          </ul>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>4. User Conduct</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6', marginBottom: '12px' }}>
            You agree not to:
          </p>
          <ul style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Use cheats, exploits, automation software, bots, or any unauthorized third-party software</li>
            <li>Harass, abuse, or harm other players</li>
            <li>Impersonate any person or entity</li>
            <li>Attempt to gain unauthorized access to the Game or its systems</li>
            <li>Use the Game for any illegal purpose</li>
            <li>Sell, trade, or transfer your account to another person</li>
          </ul>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>5. Intellectual Property</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            All content in the Game, including but not limited to graphics, gameplay, music, and code, 
            is owned by us or our licensors and is protected by intellectual property laws. You may not 
            copy, modify, distribute, or create derivative works without our express permission.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>6. Virtual Items</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            Any virtual items, currency, or assets in the Game are licensed to you, not sold. We reserve 
            the right to modify, remove, or reset virtual items at any time. Virtual items have no real-world value.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>7. Termination</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            We may suspend or terminate your access to the Game at any time, with or without cause, 
            with or without notice. Upon termination, your right to use the Game will immediately cease.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>8. Disclaimer of Warranties</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            THE GAME IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT 
            WARRANT THAT THE GAME WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF HARMFUL COMPONENTS.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>9. Limitation of Liability</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
            SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE GAME.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>10. Changes to Terms</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            We reserve the right to modify these Terms at any time. Continued use of the Game after 
            changes constitutes acceptance of the new Terms.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>11. Governing Law</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            These Terms shall be governed by and construed in accordance with applicable laws, 
            without regard to conflict of law principles.
          </p>
        </section>

        <section style={{ marginBottom: '24px' }}>
          <h2 style={{ fontSize: '16px', marginBottom: '12px', color: '#e2e8f0' }}>12. Contact</h2>
          <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: '1.6' }}>
            If you have any questions about these Terms, please contact us through our game support channels.
          </p>
        </section>

        <button
          onClick={onBack}
          style={{
            background: '#21262d',
            border: '1px solid #30363d',
            color: '#e2e8f0',
            padding: '8px 16px',
            cursor: 'pointer',
            marginTop: '16px',
            fontSize: '12px',
            width: '100%',
          }}
        >
          ← Back to Sign In
        </button>

        <div style={{ height: '40px' }} />
      </div>
    </div>
  );
};
